import { Container, Row, Col } from "react-bootstrap";

import Nav from "../components/general/NavBar.jsx";
import Footer from "../components/general/footer.jsx";
import ContactCorp from "../components/contact/ContactCorp.jsx";

const Contact = () => {
  return (
    <section>
      <div className="contact-bg">
        <Container>
          <Nav />
          <ContactCorp />
        </Container>
      </div>
      <Footer border="contact" />
    </section>
  );
};

export default Contact;